import PropTypes from "prop-types";
// MUI components
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip"; // Import Tooltip
// redux
import { useDispatch, useSelector } from "react-redux";
import { loadProductListState } from "store/features/respondentDashboardSlice";
import { loadClaimsAnalysisSelectedTagsFilterState } from "../../store/features/claimsAnalysisSlice";
import { loadIsFilterAcrossProductsState, loadMissingFiltersState, loadCurrentSelectedFiltersState, loadCurrentSelectedAllFiltersState } from "../../store/features/consumerFilterSlice";
import {
    loadAgreementAnalysisResultState,
    loadOverallAnalysisResultState,
    loadSecondaryAnalysisResultState,
    loadClaimsAnalysisResultState,
    loadJustRightAnalysisResultState,
    loadFragranceMetricsAnalysisResultState,
    loadPreferenceAnalysisResultState,
    loadProductPreferenceAnalysisResultState,
    loadFragranceAssociationResultState,
    loadWeightToggleState,
    loadDisableWeightToggleState,
    loadIsItmDataShownState,
    loadOverallToggleState,
    loadTop2BoxAggToggleState,
    loadTop2BoxClaimsToggleState,
    loadDataViewState,
    loadSignificanceToggleState,
    loadDisableSignificanceToggleState,
    loadPercentageToggleState,
    loadChartScaleResetState,
} from "../../store/features/analysisResultsSlice";
import { resetAnalysisTypeSelectionStoreState } from "../../store/features/analysisTypeSelectionSlice";
import { loadProductOrderState, loadProductsVisibility } from "../../store/features/productsInfoSlice";
// import { loadIsFilterAcrossProductsForCorrelationState, loadMissingFiltersForCorrelationState, loadCurrentSelectedFiltersForCorrelationState, loadCurrentSelectedAllFiltersForCorrelationState } from "../../store/features/correlationSlice";
import { loadAgreementRemovedKpiListState, loadOverallRemovedKpiListState, loadSecondaryRemovedKpiListState, loadClaimsRemovedKpiListState, loadJustRightRemovedKpiListState, loadFragranceMetricsRemovedKpiListState, loadPreferenceRemovedKpiListState } from "../../store/features/analysisKpiSlice";

function Reset({ clearTTestResult = () => {} }) {
    //REDUX
    const dispatch = useDispatch();
    const defaultAgreementAnalysisResult = useSelector((state) => state.analysisResultsStore.defaultAgreementAnalysisResult);
    const defaultOverallAnalysisResult = useSelector((state) => state.analysisResultsStore.defaultOverallAnalysisResult);
    const defaultSecondaryAnalysisResult = useSelector((state) => state.analysisResultsStore.defaultSecondaryAnalysisResult);
    const defaultClaimsAnalysisResult = useSelector((state) => state.analysisResultsStore.defaultClaimsAnalysisResult);
    const defaultJustRightAnalysisResult = useSelector((state) => state.analysisResultsStore.defaultJustRightAnalysisResult);
    const defaultFragranceMetricsAnalysisResult = useSelector((state) => state.analysisResultsStore.defaultFragranceMetricsAnalysisResult);
    const defaultPreferenceAnalysisResult = useSelector((state) => state.analysisResultsStore.defaultPreferenceAnalysisResult);
    const defaultProductPreferenceAnalysisResult = useSelector((state) => state.analysisResultsStore.defaultProductPreferenceAnalysisResult);
    const defaultFragranceAssociationResult = useSelector((state) => state.analysisResultsStore.defaultFragranceAssociationResult);
    const selectedStudies = useSelector((state) => state.studyDataStore.selectedStudies);
    const currentFilterStoreData = JSON.stringify(useSelector((state) => state.consumerFilterStore.currentSelectedFilters)) || {};
    const currentFilterAllStoreData = JSON.stringify(useSelector((state) => state.consumerFilterStore.currentSelectedAllFilters)) || {};
    // const currentFilterForCorrelationStoreData = JSON.stringify(useSelector((state) => state.correlationStore.currentSelectedFiltersForCorrelation)) || {};
    // const currentFilterAllForCorrelationStoreData = JSON.stringify(useSelector((state) => state.correlationStore.currentSelectedAllFiltersForCorrelation)) || {};
    const defaultProductsOrder = useSelector((state) => state.productsInfoStore.defaultProductsOrder);
    // const defaultCorrelationAnalysisResult = useSelector((state) => state.correlationStore.defaultCorrelationAnalysisResult);

    const resetCf = (consumerFilterStr = {}) => {
        const updatedCf = JSON.parse(consumerFilterStr.replaceAll(":true}", ":false}"));
        return updatedCf;
    };

    const resetAllCf = (consumerFilterStr = {}) => {
        const updatedCf = JSON.parse(consumerFilterStr.replaceAll(":true", ":false"));
        return updatedCf;
    };

    const handleReset = () => {
        // filters
        dispatch(loadClaimsAnalysisSelectedTagsFilterState([]));
        dispatch(loadIsFilterAcrossProductsState(false));
        dispatch(loadMissingFiltersState({}));
        dispatch(loadCurrentSelectedFiltersState(resetCf(currentFilterStoreData)));
        dispatch(loadCurrentSelectedAllFiltersState(resetAllCf(currentFilterAllStoreData)));

        // analysis results
        dispatch(loadAgreementAnalysisResultState(defaultAgreementAnalysisResult));
        dispatch(loadOverallAnalysisResultState(defaultOverallAnalysisResult));
        dispatch(loadSecondaryAnalysisResultState(defaultSecondaryAnalysisResult));
        dispatch(loadClaimsAnalysisResultState(defaultClaimsAnalysisResult));
        dispatch(loadJustRightAnalysisResultState(defaultJustRightAnalysisResult));
        dispatch(loadFragranceMetricsAnalysisResultState(defaultFragranceMetricsAnalysisResult));
        dispatch(loadPreferenceAnalysisResultState(defaultPreferenceAnalysisResult));
        dispatch(loadProductPreferenceAnalysisResultState(defaultProductPreferenceAnalysisResult));
        dispatch(loadFragranceAssociationResultState(defaultFragranceAssociationResult));

        // product visibility
        dispatch(loadProductOrderState(defaultProductsOrder));
        dispatch(loadProductsVisibility({}));

        // common toggle
        dispatch(loadIsItmDataShownState(false));
        dispatch(loadOverallToggleState(false));
        // Reset the Top 2-Box toggle state to its default value (DEO)
        dispatch(loadTop2BoxAggToggleState({ value: "top_2_box", label: "Top 2-Box %" }));
        // Reset the Top 2-Box toggle state for claims to its default value (DEO)
        dispatch(loadTop2BoxClaimsToggleState({ value: "top_2_box", label: "Top 2-Box %" }));
        // Reset the data view state to its default value (mean) (Oral care)
        dispatch(loadDataViewState({ value: "mean", label: "Mean" }));

        // kpi visibility
        dispatch(loadOverallRemovedKpiListState([]));
        dispatch(loadSecondaryRemovedKpiListState([]));
        dispatch(loadAgreementRemovedKpiListState([]));
        dispatch(loadClaimsRemovedKpiListState([]));
        dispatch(loadJustRightRemovedKpiListState([]));
        dispatch(loadFragranceMetricsRemovedKpiListState([]));
        dispatch(loadPreferenceRemovedKpiListState([]));
        clearTTestResult();

        // significance toggle
        dispatch(loadSignificanceToggleState(false));
        dispatch(loadDisableSignificanceToggleState(true));

        // preference percentage toggle
        dispatch(loadPercentageToggleState(false));

        // respondent
        dispatch(loadProductListState([]));
        dispatch(resetAnalysisTypeSelectionStoreState());

        // chart scale reset
        dispatch(loadChartScaleResetState(false));

        // weight toggle
        const arr = [];
        selectedStudies.forEach((item) => {
            arr.push(item?.["weighted"]);
        });
        const flag = arr.some((ele) => ele === true);
        if (flag) {
            dispatch(loadWeightToggleState(flag));
            dispatch(loadDisableWeightToggleState(!flag));
        }
    };
    return (
        <Tooltip
            title="Reset Default Study View"
            placement="top-end"
        >
            <Button
                size="small"
                className="custom-btn liner-light-blue-background me-4 bold-content"
                variant="contained"
                onClick={handleReset}
            >
                Reset
            </Button>
        </Tooltip>
    );
}
Reset.propTypes = {
    // resetCorrelation: PropTypes.func,
    clearTTestResult: PropTypes.func,
};
export default Reset;
